import React, { Fragment, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Packages
import { Button, Container, FloatingLabel, Form, Modal, Spinner } from 'react-bootstrap';
import Lottie from 'lottie-react';
import PropTypes from 'prop-types';

// Components
import SelectButton from '../../../utils/SelectButton';
import Alert from '../../../utils/Alert';

// Actions
import { global_config_create, global_config_group_create } from '../../../../actions/globalActions';

// Utils
import errorExists from '../../../../utils/errorExists';

// Icons
import checkAnimation from '../../../../static/icons/checkAnimation.json';

const GroupForm = (props) => {
	const { show, onHide, filters } = props;

	const dispatch = useDispatch();

	const { global_config_groups_create_loading, global_config_groups_create_success, global_errors } = useSelector(state => state.global);

	const initialAlert = { display: false, type: '', msg: '' };
	const [alert, setAlert] = useState(initialAlert);

	const initialGroupInfo = { label: '', name: '', description: '' };
	const [groupInfo, setGroupInfo] = useState(initialGroupInfo);

	const closeModalRef = useRef();
	const lottieRef	= useRef();

	const onChange = (e, name) => {
		setGroupInfo({ ...groupInfo, [name]: e.target.value });
	}

	const closeModal = () => {
		onHide();
		setGroupInfo(initialGroupInfo);
	}

	const validateGroupInfo = groupInfo.label === '' || groupInfo.name === '' || groupInfo.description === '';

	const createGlobalConfig = () => {		
		if (validateGroupInfo) {
			setAlert({ display: true, type: 'danger', msg: 'Missing fields!' });
			return;
		}
		setAlert(initialAlert);

		const groupBody = {
			...filters,
			...groupInfo
		}
		dispatch(global_config_group_create(groupBody, closeModalRef, filters));
	}

	return (
		<Modal
			show={show}
			onHide={closeModal}
			backdrop='static'
			keyboard={false}
			size='lg'
			aria-labelledby='contained-modal-title-vcenter'
			centered
		>
			<Modal.Header closeButton>
				<Modal.Title>Create Group</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				{alert.display && <Alert type={alert.type} msg={alert.msg} />}
				
				{errorExists(global_errors, 'global_config_group_create') &&
					<Alert type='danger' msg={global_errors['global_config_group_create'].msg} />
				}

				<Form>
					<FloatingLabel
						controlId='floatingInput'
						label='Label'
						className='mb-3'
					>
						<Form.Control placeholder='Label' onChange={(e) => onChange(e, 'label')} />
					</FloatingLabel>
					<FloatingLabel
						controlId='floatingInput'
						label='Name'
						className='mb-3'
					>
						<Form.Control placeholder='Name' onChange={(e) => onChange(e, 'name')} />
					</FloatingLabel>
					<FloatingLabel
						controlId='floatingInput'
						label='Description'
						className='mb-3'
					>
						<Form.Control placeholder='Description' onChange={(e) => onChange(e, 'description')} />
					</FloatingLabel>
				</Form>
			</Modal.Body>
			<Modal.Footer>
				<Button variant='outline-secondary' onClick={closeModal} ref={closeModalRef}>Cancel</Button>
				<Button 
					className={global_config_groups_create_success ? 'success-btn' : 'submit-btn'}
					onClick={createGlobalConfig}
				>
					{global_config_groups_create_success
						?	<Lottie
								loop={false}
								lottieRef={lottieRef}
								animationData={checkAnimation}
								style={{ height: '24px' }}
							/>
						:	global_config_groups_create_loading
							?	<Fragment>
									<Spinner className='me-2' as='span' animation='border' size='sm' role='status' aria-hidden='true' />
									Creating
								</Fragment>
							:	'Create'
					}
				</Button>
			</Modal.Footer>
		</Modal>
	)
}

GroupForm.propTypes = {
	show: PropTypes.bool.isRequired,
	onHide: PropTypes.func.isRequired,
	filters: PropTypes.object.isRequired
}

export default GroupForm;
